import React from 'react';
import { Colors } from '@user-portal/wikr-components';
import { CheckCircle, CrossCircle } from 'components/Icon';

const ACTIVE_COLOR: Colors = 'success-default';
const INACTIVE_COLOR: Colors = 'border-default';
const CANCELLED_COLOR: Colors = 'critical-default';

const StatusIcon = ({ isActive, isCancelled }: { isActive: boolean; isCancelled?: boolean }) => {
  if (isCancelled) {
    return <CrossCircle color={CANCELLED_COLOR} />;
  }

  return <CheckCircle color={isActive ? ACTIVE_COLOR : INACTIVE_COLOR} />;
};

export default StatusIcon;
